import React from 'react'
import { Modal } from 'antd'
import { useDispatch } from 'react-redux'
import CreateComputerScienceAssignmentForm from './CreateComputerScienceAssignmentForm'
import { toggleCreateComputerScienceAssignmentModal } from '../../../../../../../store/slices/assignment.slice'

const CreateComputerScienceAssignmentModal = () => {
    const dispatch = useDispatch()

    return (
        <Modal
            open
            title='Create Computer Science Assignment'
            onCancel={() => dispatch(toggleCreateComputerScienceAssignmentModal())}
            footer={null}
            destroyOnClose
        >
            <CreateComputerScienceAssignmentForm />
        </Modal>
    )
}

export default CreateComputerScienceAssignmentModal
